import React from 'react';
import { DateInput } from "@mantine/dates";

function AcaUnitDateInput({ form, name, label, description = null, disabled = false }) {
    const rawValue = form.values?.[name];
    const dateValue = rawValue
        ? (rawValue instanceof Date ? rawValue : new Date(rawValue))
        : null;

    return (
        <DateInput
            label={label}
            description={description}
            disabled={disabled}
            locale="es"
            placeholder="dd/mm/yyyy"
            valueFormat="DD/MM/YYYY"
            autoComplete="off"
            clearable
            value={dateValue && !isNaN(dateValue.getTime()) ? dateValue : null}
            onChange={(value) => {
                if (!value) {
                    form.setFieldValue(name, null);
                    return;
                }
                const d = value instanceof Date ? value : new Date(value);
                form.setFieldValue(name, isNaN(d.getTime()) ? null : d);
            }}
            error={form?.errors?.[name]}
        />
    );
}

export default AcaUnitDateInput;